import { TOUR_CHAPTERS, type TourTrackId } from './tour-chapters';
import { TOUR_SCENES } from './tour-scenes';

export const TOUR_SCENE_PARAM = 'scene';

export function trackOfScene(sceneId: string | null | undefined): TourTrackId | undefined {
  const scene = sceneId ? TOUR_SCENES.find((entry) => entry.id === sceneId) : undefined;
  return scene ? TOUR_CHAPTERS.find((chapter) => chapter.id === scene.chapter)?.track : undefined;
}

export function tourHref(sceneId: string): string {
  return `/?${TOUR_SCENE_PARAM}=${encodeURIComponent(sceneId)}#tour`;
}
